export default __webpack_public_path__ + "f57a62e9efddf6ace18b15572f81905b.woff2";